import type { SVGProps } from "react";
const SvgSpringboot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 256 256"
    {...props}
  >
    <path fill="#fff" d="M0 0h256v256H0z" />
    <path
      fill="#6DB33F"
      d="m241.031 114.945-45.722-79.39C191.351 28.66 181.615 23 173.654 23H82.301c-7.916 0-17.698 5.661-21.656 12.555l-45.677 79.39c-3.957 6.894-3.957 18.17 0 25.064l45.677 79.436C64.603 226.339 74.34 232 82.301 232h91.398c7.916 0 17.652-5.661 21.656-12.555l45.676-79.436c3.958-6.894 3.958-18.17 0-25.064M118.105 66.918c0-5.204 4.231-9.45 9.417-9.45 5.187 0 9.418 4.246 9.418 9.45v56.473c0 5.205-4.231 9.45-9.418 9.45s-9.417-4.245-9.417-9.45zm9.417 120.57c-35.213 0-63.874-28.761-63.874-64.097a64.46 64.46 0 0 1 25.795-51.45 8.35 8.35 0 0 1 11.738 1.734 8.417 8.417 0 0 1-1.729 11.779c-20.882 15.567-25.25 45.196-9.736 66.151s45.04 25.337 65.922 9.77c11.965-8.903 19.017-23.01 19.017-37.984-.046-15.02-7.143-29.127-19.199-38.074-3.731-2.74-4.504-8.035-1.774-11.779s8.007-4.52 11.737-1.78c16.333 12.098 25.932 31.272 25.978 51.633 0 35.381-28.662 64.097-63.875 64.097"
    />
  </svg>
);
export default SvgSpringboot;
